// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumbs_Breadcrumb__2mkiJ","JZWIT":"Breadcrumbs_JZWIT__3SA4K","JZWITIcon":"Breadcrumbs_JZWITIcon__1No9D","last":"Breadcrumbs_last__2qm_I"};